import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SegmentedControlButtonModule } from './segmented-control-button/segmented-control-button.module';
import { SegmentedControlComponent } from './segmented-control.component';

@NgModule({
  exports: [SegmentedControlComponent],
  imports: [SegmentedControlButtonModule, CommonModule, SegmentedControlComponent],
})
export class SegmentedControlModule {}
export { SegmentedControlComponent } from './segmented-control.component';
